module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 choices.map(function(choice) { ;
__p += '\n<input type="radio" name="' +
((__t = ( name )) == null ? '' : __t) +
'" value="' +
((__t = ( choice[0] )) == null ? '' : __t) +
'"';
 if (value === choice[0]) { ;
__p += ' checked';
 } ;
__p += ' />\n<label for="' +
((__t = ( choice[1] )) == null ? '' : __t) +
'">' +
((__t = ( choice[1] )) == null ? '' : __t) +
'</label>\n';
 }) ;


}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/ejs-loader!./~/icarus-forms/module/js/templates/controls/radio.ejs
// module id = 209
// module chunks = 2 3